// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ModuleDeployment  {
    _originalTypeClassName = "LoomTenantManagement.BO.ModuleDeployment";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ModuleDeployment.translate = translateService;
}
this.Id = null;
this.Name = null;
this.ContainerRegistry = null;
this.ContainerImage = null;
this.ContainerImageId = null;
this.Version = null;
this.LatestVersion = null;
this.IsBehind = false;
this.Status = null;
this.State = null;
this.DeploymentToken = null;
this.LastUpdatedOn = null;
this.PortainerUrl = null;
this._key = this.Id = ""; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
ContainerRegistry:any;
ContainerImage:any;
ContainerImageId:any;
Version:any;
LatestVersion:any;
IsBehind:any;
Status:any;
State:any;
DeploymentToken:any;
LastUpdatedOn:any;
PortainerUrl:any;
Deployment:any;
static setDeployment = ($this, value) => {
var oldValue = $this.Deployment;
$this.Deployment = value;
if (value != null) {
if (oldValue != null) {
Domain.DeploymentSettings.removeModuleDeployments(oldValue, $this);
}
Domain.DeploymentSettings.addModuleDeployments(value, $this);
}
}

static GetIsBehind($this: any): any{if ((CLMS.Framework.String.IsNullOrEmpty(($this?.LatestVersion ?? '').trim()))) {return false;}
if (($this?.Version == "latest" || $this?.Version == "develop")) {return false;}
return $this?.Version != $this?.LatestVersion;
}
static GetPortainerUrl($this: any): any{let url_template = "https://portainer.loom.konnecta.io:9443/#!/{0}/docker/containers/{1}";
return CLMS.Framework.String.Format(url_template, $this?.Deployment?.PortainerEndpointId, $this?.Id);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == "";
            }


}